// Feature flag of the unified Connections page (/settings/connections and its channel subpages).
// Read at call time, not at import, so a spec can switch it with vi.stubEnv. Off, the old Settings
// -> Connections page renders unchanged. Keep .env.staging identical to .env.production.
export const isConnectionsV2Enabled = () => import.meta.env.VITE_ENABLE_CONNECTIONS_V2 === 'true';

// Where a sign-in return or a "back to connections" lands for one channel: the channel's subpage
// when the page is on, else its old page (`legacyPath`). Call it where it is used, not at import.
export const channelPagePath = (key, legacyPath) =>
  isConnectionsV2Enabled() ? `/settings/connections/${key}` : legacyPath;
